import { sdkRequest } from '@eventbrite/http';
import type {
    AsyncActionOptions,
    AutoCreateEventFormValues,
} from '../types';
import { TimezoneDTO } from '@eventbrite/create-common';
import { createTransientEventPayload } from './adapters';

export const createTransientEvent = async ({
    values,
    userTimezone,
    locale,
    options,
}: {
    values: AutoCreateEventFormValues;
    userTimezone?: TimezoneDTO;
    locale?: string;
    options?: AsyncActionOptions;
}) => {
    if (options?.testingFlags.shouldError) {
        await new Promise((resolve) => setTimeout(resolve, 1700));
        throw new Error('Error creating transient event');
    }

    const payload = createTransientEventPayload({
        values,
        userTimezone,
        locale,
    });

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
    };

    return sdkRequest('/event-auto-create-preview', requestOptions);
};
